import { ApplicationUser } from "../../all_Interfaces"

export type FundConfigModel = {
    fundID: string,
    fundName: string,
    investmentType: string,
    appraisalSchedule: string,
    isFiduciaryApprovalRequired: boolean,
    delayPosting: number,
    scheduleDayAppraisal: string,
    scheduleDelayCount: number,
    workflowtemplate: string,
    workflowVersion: string,
    region: string,
    isBlackOutRequired: boolean,
    isValuationTypeRequired: boolean,
    percentageChange: number,
    id: number,
    createdBy: string | undefined,
    created: string,
    lastModifiedBy: string | undefined,
    lastModified: string
}

export type FundModel = {
    fundID: string,
    fundName: string,
    region: string,
    id: number | string,
    createdBy: string | undefined,
    created: string,
    lastModifiedBy: string | undefined,
    lastModified: string
}


export type TodoModel = {
    appraisalId: string,
    reviewStatus: string,
    investmentId: string,
    investment: string,
    investmentType: string,
    fund: string ,
    appraisalDate: string,
    appraisalType: string,
    lastModified: string
}

export type RoleModel = {
    role: string,
    region: string,
    id: number,
    lastModifiedBy: string | undefined,
    lastModified: string
}

export type lazyloadingFilters = {
    value?: any,
    matchMode?: string,
    identity: string
}



export class GlobalAppraisalModel  {
    appraisalId!: string;
    fundName!: string;
    fundId!: string;
    status!: string;
    valueDate!: string;
    appraiser1!: ApplicationUser;
    appraiser2!: any;
    workflowId!: string;
    workFlowSteps!: string;
    appraisalRejecetd!: string;
    activeIndex!: string;
    currency!: string;
    postedAppraisalDate!: string;
    portfolioManager!: ApplicationUser;
    numOfTenants!: number | string | null;
    netRentPassing!: number | string | null;
    rentalValue!: number | string | null;
    grossValue!: number | string | null;
    capitalExpenditure!: number | string | null;
    acquisitionCosts!: number | string | null;
    netValue!: number | string | null;
    sayValue!: number | string | null;
    initialYieldValuation!: string;
    initialYieldContracted!: string;
    nominalEquivalentYield!: number;
    trueEquivalentYield!: number;
    reversionaryYield!: number;
    createdBy!: string;
    created!: string;
    lastModifiedBy!: string;
    lastModified!: string;
    properties!: Properties[];
    scenarioId!: string;
    displayProformaFields!:boolean;
}

export class GlobalAppraisalModelPost {
    appraisalId!: string;
    fundName!: string;
    fundId!: string;
    status!: string;
    valueDate!: any;
    appraiser1!:ApplicationUser;
    appraiser2!: any;
    workflowId!: string;
    workFlowSteps!: string;
    appraisalRejecetd!: string;
    activeIndex!: string;
    currency!: string;
    postedAppraisalDate!: string;
    portfolioManager!: ApplicationUser;
    numOfTenants!: string | null | number;
    netRentPassing!: string | null | number;
    rentalValue!: string | number | null;
    grossValue!: string | number | null;
    capitalExpenditure!: string | number | null;
    acquisitionCosts!: string | number | null;
    netValue!: string | number | null;
    sayValue!: string | number | null;
    initialYieldValuation!: string;
    initialYieldContracted!: string;
    nominalEquivalentYield!: number;
    trueEquivalentYield!: number;
    reversionaryYield!: number;
    createdBy!: string | undefined;
    created!: string;
    lastModifiedBy!: string;
    lastModified!: string;
    properties!: Properties[];
    scenarioId!: string;
    displayProformaFields!:boolean;
}

export class Properties {
    propertyId!: string;
    propertyName!: string;
    propertyType!: string;
    assetManager!: ApplicationUser;
    sectorHead!: ApplicationUser;
    currency!: string;
    rentalValue!: number | string | null;
    netRentPassing!: number | string | null;
    grossValue!: number | string | null;
    capitalExpenditure!: number | string | null;
    acquisitionCosts!: number | string | null;
    netValue!: number | string | null;
    sayValue!: number | string | null;
    initialYieldValuation!: number | string;
    initialYieldContracted!: number | string;
    nominalEquivalentYield!: number | string;
    trueEquivalentYield!: number | string;
    reversionaryYield!: number | string;
    createdBy!: string;
    created!: string;
    lastModifiedBy!: string;
    lastModified!: string;
    argusExternalId!: string;
    propertyValueDate!:string;
    terminalCapRate!: number | string;
    discountRate!: number | string;
    assumedHoldingPeriod!: number | string | null;
    growthRates!: number | string;
    netExitValue!: number | string | null;
    forwardInitialYield!: number | string;
}

export type GlobalAppraisalFetched = {
    fundName: string,
    effectiveDateValue: String,
    portfolioManager: string,
    noOfTenants: string,
    netRentPassing: string,
    rentalValue: string,
    grossValue: string,
    capitalExpenditure: string,
    acquisitionCosts: string,
    netValue: string,
    sayValue: string,
    initialYieldValuationRent: string,
    initialYieldContractedRent: string,
    nominalEquivalentYield: string,
    trueEquivalentYield: string,
    reversionaryYield: string,
    properties: Properties[] | []
}

export class Appraiser1 {
    firstName!: string;
    lastName!: string;
    name!: string;
    email!: string;
    userType!: string;
}

export type FundDDL = {
    fundId: string,
    fundName: string
}

export class UserRoleMap {
    id!: number;
    userName!: string;
    userID!: string;
    userType!: string;
    email!: string;
    role!: string;
    oldRole!: string;
    fundId!: string;
    fundName!: string;
    investmentType!: string;
    region!: string;
    status!: string;
    firm!: string;
    firstName!: string;
    lastName!: string;
    createdBy!: string;
    created!: string;
    lastModifiedBy!: string;
    lastModified!: string;
    showDelete: boolean = false;
    isDeletedAndArchivedRole: boolean = false;
  }